import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class Fax {
  static status () {
    return http.post('fax/status')
  }

  static outbound (params) {
    return http.post('fax/outbound', params)
  }

  static inbound (params) {
    return http.post('fax/inbound', params)
  }

  static async send (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('fax/send', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  // PDF 는 CRM 이 팩스 서버에서 받아 프록시한다. 바이너리로 받아야 한다.
  static file (params) {
    return http.post('fax/file', params, { responseType: 'blob' })
  }

  static markRead (params) {
    return http.post('fax/mark-read', params)
  }
}

export default Fax
